import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { forwardRef } from 'react';
const defaultVideoStreamPlayerConfig = {
    autoPlay: undefined,
    muted: false,
    controls: true,
    controlsList: 'nodownload'
};
const b = bemClassBuilder('v-video-player');
export const DefaultVideoPlayer = forwardRef((props, forwardedRef) => {
    const { src, className } = props, videoAttributes = __rest(props, ["src", "className"]);
    return (_jsx("video", Object.assign({}, defaultVideoStreamPlayerConfig, videoAttributes, { className: b.element('video', undefined, className), ref: forwardedRef }, { children: _jsx("source", { src: src }) })));
});
DefaultVideoPlayer.displayName = 'DefaultVideoPlayer';
